import { AxiosInstance } from 'axios';
import { ArgumentValidator } from '../../helpers';
import { IHttpError, IUserFileImportProcess, IUserFileImportRequest, IUserFileImportValidationRequest } from '../models';
import { IUserFileImportDocumentation } from '../models/user-file-import-documentation';

export class UserFileImportProcessClient {

    constructor(private axiosClient: AxiosInstance) {

    }

    public get apiUrl() {
        return `/userFileImportProcess`;
    }

    public async initiateUsingExcelFile(fileIdPrefix: string): Promise<IUserFileImportProcess> {

        ArgumentValidator.notNullOrEmpty(fileIdPrefix, 'fileId');

        try {

            const response = await this.axiosClient.post(`${this.apiUrl}/initiate/usingExcelFile/${fileIdPrefix}`);

            return response.data;

        } catch (error: any) {

            throw error.response.data as IHttpError;
        }
    }

    public async validate(processIdPrefix: string, request: IUserFileImportValidationRequest, enableDeletion: boolean): Promise<IUserFileImportProcess> {

        ArgumentValidator.notNullOrEmpty(processIdPrefix, 'processIdPrefix');

        try {

            const response = await this.axiosClient.post(`${this.apiUrl}/validate/${processIdPrefix}?enableDeletion=${enableDeletion}`, request);

            return response.data;

        } catch (error: any) {

            throw error.response.data as IHttpError;
        }
    }

    public async import(processIdPrefix: string, request: IUserFileImportRequest): Promise<IUserFileImportProcess> {

        try {

            ArgumentValidator.notNullOrEmpty(processIdPrefix, 'processIdPrefix');

            const response = await this.axiosClient.post(`${this.apiUrl}/import/${processIdPrefix}`, request);

            return response.data;

        } catch (error: any) {

            throw error.response.data as IHttpError;
        }
    }

    public async get(processIdPrefix: string): Promise<IUserFileImportProcess> {

        try {

            ArgumentValidator.notNullOrEmpty(processIdPrefix, 'processIdPrefix');

            const response = await this.axiosClient.get(`${this.apiUrl}/${processIdPrefix}`);

            return response.data;

        } catch (error: any) {

            throw error.response.data as IHttpError;
        }
    }

    public async getDocumentation(): Promise<IUserFileImportDocumentation> {

        try {

            const response = await this.axiosClient.get(`${this.apiUrl}/documentation`);

            return response.data;

        } catch (error: any) {

            throw error.response.data as IHttpError;
        }
    }
}
